enum Language {
  NO = 'NO',
  ENG = 'EN'
}

export default Language;
